import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

const Section = (props: BoxProps) => {
  return <Box as="section" p="9rem 1.5rem" {...props} />
}

export default Section
